export default class templatesWorker {

    constructor() {
    }

    fillUserData(container, userID, userName, avatarSrc, userType, isOnline, time, verified = false, subscriber = false, follower = false, payments = null, messageData = null) {
        let containerType = $(container).attr('data-type');

        if (containerType == 'camchat-header' || containerType == 'chat-message') {
            $(container).find('[data-type="user-href"]').attr('target', '_blank');
        }
        $(container).find('[data-type="username"]').html(userName);
        $(container).find('[data-type="avatar-img"]').attr('src', avatarSrc).attr('alt', userName);
        $(container).find('[data-type="user-href"]').removeClass('hidden');

        switch (userType) {
            case 4:
                $(container).find('[data-type="adminbadge"]').removeClass('hidden');
                break;

            case 5:
                $(container).find('[data-type="adminbadge"]').removeClass('hidden');
                break;

            case 2:
                if (verified) {
                    $(container).find('[data-type_2="verifyedbadge--blue"]').removeClass('hidden');
                    $(container).find('[data-type="verifyedbadge"]').addClass('hidden');
                } else {
                    $(container).find('[data-type="verifyedbadge"]').removeClass('hidden');
                }
                break;

            case 1:
                if (subscriber) {
                    $(container).find('[data-type="subbadge"]').removeClass('hidden');
                }
                if (follower) {
                    $(container).find('[data-type="followbadge"]').removeClass('hidden');
                }

                break;
        }

        if (isOnline) {
            $(container).find('.js-avatar').addClass('user-avatar--green');
        }

        let currentUrl = new URL(window.location);
        let userURL = currentUrl.origin + '/' + userName;

        $(container).find('.js-avatar').attr('href', userURL);
        $(container).find('[data-type="user-href"]').attr('href', userURL);
        $(container).find('[data-type="user-payments"]').attr('href', userURL);

        $(container).find('.js-time').html(time);
        $(container).find('[data-type="user-payments"]').html(payments);

        // In manchen Nachrichten, die eine Antwort auf eine andere Nachricht sind, gibt es einen zweiten Avatar – für den Ersteller der Originalnachricht.
        // Dieser Avatar muss aktualisiert werden:
        let $avatarContainer = $(container).find('.js-avatar');

        if ($avatarContainer.length > 1 && messageData != null) {
            let replyUserURL = currentUrl.origin + '/' + messageData.reply_username;
            $avatarContainer.last().attr('href', replyUserURL);

            let $avatarImgContainer = $(container).find('[data-type="avatar-img"]');
            $avatarImgContainer.last().attr('src', messageData.reply_avatar).attr('alt', messageData.reply_username);

            if (messageData.isReplyOnline) {
                $avatarContainer.last().addClass('user-avatar--green');
            } else {
                $avatarContainer.last().removeClass('user-avatar--green');
            }
        }
    }

    createNewConversation($parentContainer, conversationID) {
        //js-conversation_form_tpl

        let $conversation = $('<div></div>');
        $conversation.attr('id', 'conversation_' + conversationID);
        $conversation.addClass('hidden');
        $conversation.addClass('h-100');
        $conversation.addClass('conversation_container');

        $parentContainer.append($conversation);
        return $conversation;
    }

    loadConversationTemplate($parentContainer, conversationID) {
        let $template = $("#js-conversation_tpl").contents().clone();

        let imgUploadDataUrl = $template.find('[data-modal-id="messenger-imgupload"]').attr('data-url');
        if (imgUploadDataUrl.length > 0) {
            imgUploadDataUrl = imgUploadDataUrl + '/' + conversationID;
            $template.find('[data-modal-id="messenger-imgupload"]').attr('data-url', imgUploadDataUrl);
        }

        let $tipModalBtn = $template.find('[data-modal-id="messenger-tip"]');
        if ($tipModalBtn.length > 0) {
            let tipModalData = 'conversationID=' + conversationID;
            $tipModalBtn.attr('data-modaldata', tipModalData);
        }

        $parentContainer.html($template);

        let $header = $parentContainer.children('.js-header').first();
        return $header;
    }

    loadImagePreloaderTemplate(imageUrl, imageQuality = 1, lightbox = false, lightboxIcon = false, isGalleryItem = false, isActive = false, loadingSpinnerText = false) {
        let $imagePreloader = this.getTemplate('js-imagepreloader_tpl');
        $imagePreloader.attr('data-url', imageUrl);
        $imagePreloader.attr('data-img-quality', imageQuality);
        $imagePreloader.attr('data-lightbox', lightbox);

        if (isGalleryItem) {
            $imagePreloader.attr('data-gallery-item', "true");
        }

        if (isActive) {
            $imagePreloader.addClass('active');
        }

        if (lightboxIcon) {
            $imagePreloader.attr('data-lightbox-icon', 1)
        }

        if (loadingSpinnerText) {
            $imagePreloader.attr('data-loading-spinner-text', 1);
            $imagePreloader.find('[data-type="loading-spinner-text"]').removeClass('hidden');
        }

        return $imagePreloader;
    }

    loadVideoPreloaderTemplate(videoUrl, imagePreview = false, lightboxIcon = false, isGalleryItem = false, isActive = false, loadingSpinnerText = false) {
        let $videoPreloader = this.getTemplate('js-videopreloader_tpl');
        $videoPreloader.attr('data-url', videoUrl);
        if (imagePreview) {
            $videoPreloader.attr('data-preview-type', "image");
        } else {
            $videoPreloader.attr('data-preview-type', "video");
        }
        if (isGalleryItem) {
            $videoPreloader.attr('data-gallery-item', "true");
        }
        if (isActive) {
            $videoPreloader.addClass('active');
        }
        if (lightboxIcon) {
            $videoPreloader.attr('data-lightbox-icon', 1)
        }
        if (loadingSpinnerText) {
            $videoPreloader.attr('data-loading-spinner-text', 1);
            $videoPreloader.find('[data-type="loading-spinner-text"]').removeClass('hidden');
        }
        return $videoPreloader;
    }

    loadVideoPartPreloaderTemplate(videoUrl, imageData, imageQuality = 1, lightboxIcon = false, isGalleryItem = false, isActive = false, errorMsg = '') {
        let $videoPartPreloader = this.getTemplate('js-videopartpreloader_tpl');
        let $autosizeimage = $videoPartPreloader.find('.autosizeimage');
        let $errorBox = $videoPartPreloader.find('.error');
        $videoPartPreloader.attr('data-url', videoUrl);

        $autosizeimage.attr('data-width', imageData.width);
        $autosizeimage.attr('data-height', imageData.height);
        $autosizeimage.attr('data-aspectratio', imageData.aspectratio);
        $autosizeimage.attr('data-img-url', imageData.imgUrl);
        $autosizeimage.attr('data-img-quality', imageQuality);
        $autosizeimage.attr('data-custom-load', imageData.customLoad);

        if (isGalleryItem) {
            $videoPartPreloader.attr('data-gallery-item', "true");
        }

        if (isActive) {
            $videoPartPreloader.addClass('active');
        }

        if (lightboxIcon) {
            $videoPartPreloader.attr('data-lightbox-icon', 1)
        }

        if (errorMsg != '') {
            $videoPartPreloader.addClass('showError');

            $errorBox.html(errorMsg);
            $errorBox.removeClass('hidden');

            $autosizeimage.find('.bf-loading').addClass('hidden');
        }

        return $videoPartPreloader;
    }

    loadAutoSizeImageTemplate(imageData, imageQuality = 1, lightbox = false, lightboxIcon = false, isGalleryItem = false, isActive = false, loadingSpinnerText = false) {
        let $autosizeimage = this.getTemplate('js-autosizeimage_tpl');

        $autosizeimage.attr('data-width', imageData.width);
        $autosizeimage.attr('data-height', imageData.height);
        $autosizeimage.attr('data-aspectratio', imageData.aspectratio);
        $autosizeimage.attr('data-img-url', imageData.imgUrl);
        $autosizeimage.attr('data-img-quality', imageQuality);
        $autosizeimage.attr('data-custom-load', imageData.customLoad);

        if (lightbox) {
            $autosizeimage.attr('data-lightbox', 1);
        }

        if (isGalleryItem) {
            $autosizeimage.attr('data-gallery-item', "true");
        }

        if (isActive) {
            $autosizeimage.addClass('active');
        }

        if (lightboxIcon) {
            $autosizeimage.find('[data-type="lightbox-open"]').removeClass('hidden');
        }

        if (loadingSpinnerText) {
            $autosizeimage.find('[data-type="loading-spinner-text"]').removeClass('hidden');
        }

        return $autosizeimage;
    }

    loadVideoplayerTemplate(
        videoUrl,
        imageData,
        imageQuality = 1,
        lightbox = false,
        lightboxIcon = false,
        isGalleryItem = false,
        isActive = false,
        autoplay = false,
        loadingSpinnerText = false,
        disablePlayButton = false,
        muted = true,
    ) {
        let $videoplayer = this.getTemplate('js-videoplayer_tpl');
        let autoSizeImage = $videoplayer.find('[data-type=autosizeimage]');
        let button = $videoplayer.find('[data-action=play]');

        // wenn der Playbutton deaktiviert wurde, muss ebenfalls eine Lightbox Listener aktiv sein, da das Video ansonsten nicht abspielbar wäre
        if (lightbox || disablePlayButton) {
            $videoplayer.attr('data-lightbox', 1);
        }

        if (isGalleryItem) {
            $videoplayer.attr('data-gallery-item', "true"); // wird in css selektiert
        }

        if (isActive) {
            $videoplayer.addClass('active');
        }

        if (autoplay) {
            $videoplayer.attr('data-autoplay', 1)
        }

        if (lightboxIcon) {
            $videoplayer.find('[data-type="lightbox-open"]').removeClass('hidden');
        }

        if (disablePlayButton) {
            $videoplayer.attr('data-disable-playbutton', 1);
        }

        if (loadingSpinnerText) {
            autoSizeImage.find('[data-type="loading-spinner-text"]').removeClass('hidden');
        }

        autoSizeImage.attr('data-width', imageData.width);
        autoSizeImage.attr('data-height', imageData.height);
        autoSizeImage.attr('data-aspectratio', imageData.aspectratio);
        autoSizeImage.attr('data-img-url', imageData.imgUrl);
        autoSizeImage.attr('data-img-quality', imageQuality);

        $videoplayer.attr('data-video-url', videoUrl);
        $videoplayer.attr('data-muted', muted);

        return $videoplayer;
    }

    loadSystemMessageTemplate(messageContent) {

        let $messageContainer = this.getTemplate('js-system-message_tpl');
        $messageContainer.addClass('system_message');
        $messageContainer.attr('data-message-type', 'system');
        let $contentContainer = $messageContainer.find('[data-type="msg-content"]');
        messageContent = messageContent.replace(/\n/g, "</br>");
        $contentContainer.html(messageContent);

        return $messageContainer[0].outerHTML;
    }

    loadMessageTemplate(currentUser, $parentContainer, messageData, parentHTML, replace = false) {
        let mySelf = this;
        let $messageContainer = $parentContainer.find('[data-message-id="' + messageData.id + '"]').first();

        if ($messageContainer.length == 0 || replace) {
            let messagePayloadData = null;

            if (messageData.message_payload_data != undefined && messageData.message_payload_data != null) {
                messagePayloadData = JSON.parse(messageData.message_payload_data);
            }
            
            $messageContainer = this.getTemplate('js-message_tpl');
            $messageContainer.attr('data-message-type', 'user');

            let $mediaContainer = $messageContainer.find('[data-type="media-container"]');
            let $actionButtons = $messageContainer.find('[data-type="action-buttons"]');
            let $replyedContainer = $messageContainer.find('[data-type="replyed-content"]');
            let $contentContainer = $messageContainer.find('[data-type="msg-content"]');
            let $messageTime = $messageContainer.find('[data-type="msg-time"]');
            let $messagePrice = $messageContainer.find('[data-type="message-price"]');
            let $messagePriceWrapper = $messageContainer.find('[data-type="message-price-wrapper"]');
            let $tipBag = $messageContainer.find('[data-type="tip-bag"]');
            let $wmBadge = $messageContainer.find('[data-type="wmbadge"]');
            let $dropdownButton = $messageContainer.find('[data-type="dropdown-button"]');
            let $emojiBtn = $messageContainer.find('[data-msgtype="message"]');
            let $reactionContainer = this.getTemplate('js-message_reactions_tpl');

            // Kostenpflichtige Uploads
            let $purchaseButtonsContainer = $messageContainer.find('[data-type="purchase-buttons"]');
            let $purchaseStateHolder = $messageContainer.find('[data-type="purchase-state"]');
            let $purchaseCancelButton = $messageContainer.find('[data-type="cancel"]');
            let $avsButton = $messageContainer.find('[data-type="avs-button"]');

            let isCamChat = false;
            if (messageData.camchat != undefined && messageData.camchat) {
                isCamChat = true;
            }

            $messageContainer.attr('data-message-id', messageData.id);
            $messageContainer.attr('data-message-username', messageData.username);


            this.fillUserData($messageContainer, messageData.userID, messageData.username, messageData.avatar, messageData.usertype, messageData.isOnline, messageData.user_last_activity_at, false, false, false, null, messageData);

            if (messageData.deleted == 1) {
                // Gelöschte Nachrichten, keine weitere Verarbeitung
                if (messageData.own) {
                    $contentContainer.html($messageContainer.attr('data-deleted-own-txt'));
                } else {
                    $contentContainer.html($messageContainer.attr('data-deleted-txt'));
                }

                $mediaContainer.remove();
                $actionButtons.remove();
                $dropdownButton.remove();
                $emojiBtn.remove();

            } else {
                if (currentUser.usertype == 1 && messageData.msg_type == 'welcome_message') {
                    $wmBadge.removeClass('hidden');
                }

                $emojiBtn.attr('data-target-id', 'message-emoji-' + messageData.id);
                $emojiBtn.attr('data-content-id', messageData.id);
                $emojiBtn.attr('data-conv-id', messageData.conversation_id);

                if (messageData.reactions != undefined) {
                    let reactions = JSON.parse(messageData.reactions);

                    reactions.forEach(function (reaction) {
                        let $newReaction = $reactionContainer.clone();
                        let $messageContainerReaction = $messageContainer.find('.message_container--reaction');
                        $newReaction.attr('data-content-id', messageData.id);
                        $newReaction.attr('data-conv-id', messageData.conversation_id);

                        let $emoji = $newReaction.find('[data-type="reaction-content"]');
                        $emoji.text(reaction.reaction);
                        $emoji.attr('title', reaction.username);

                        if (reaction.count > 1) {
                            let $emojiCount = $newReaction.find('[data-type="reaction-count"]');
                            $emojiCount.text(reaction.count);
                        }

                        if (reaction.user_reacted == 1) {
                            if (currentUser.usertype == 2) {
                                $emoji.closest('div').addClass('creator_reacted');
                            } else {
                                $emoji.closest('div').addClass('user_reacted');
                            }
                        }

                        if (isCamChat) {
                            $newReaction.attr('type', 'camchat');
                        }
                        $messageContainerReaction.append($newReaction);
                    });
                }

                if (messageData.content != null) {
                    let messageContent = messageData.content.replace(/\n/g, "</br>");
                    $contentContainer.html(messageContent);

                    if (messageData.reply_message_id != null) {
                        let $replyToUsername = $replyedContainer.find('[data-type="reply-to-username"]');
                        let $replyToContent = $replyedContainer.find('[data-type="reply-to-content"]');

                        $replyToUsername.html(messageData.reply_username);

                        let originalContent = '';

                        if (messageData.reply_message_content != undefined && messageData.reply_message_content != '') {
                            originalContent = messageData.reply_message_content.replace(/\n/g, "</br>");
                        } else {
                            if (messageData.reply_message_payload_type != null) {
                                originalContent = messageData.reply_message_payload_type.toUpperCase();
                            }
                        }
                        $replyToContent.html(originalContent);

                        if (messageData.reply_deleted != undefined && messageData.reply_deleted == 1) {
                            $replyedContainer.removeClass('active');
                        } else {
                            $replyedContainer.attr('data-reply-to-message-id', messageData.reply_message_id);
                        }

                        $replyedContainer.removeClass('hidden');
                    } else {
                        $replyedContainer.remove();
                    }
                }

                if (messagePayloadData != null) {
                    try {
                        if (messagePayloadData.payload_type == 'gif' && messagePayloadData.data.downsized_medium) {
                            const gifImg = document.createElement('img');
                            gifImg.src = messagePayloadData.data.downsized_medium;
                            gifImg.alt = 'GIF';
                            gifImg.classList = 'd-block';
                            $contentContainer.append(gifImg);
                        }
                    } catch (error) {
                        console.error("An error occurred while creating elements: ", error);
                    }
                }

                // Zeitangaben
                let timeText = messageData.msgTime;
                if (isCamChat) {
                    timeText = messageData.username + ', ' + messageData.msgTime;
                    $emojiBtn.attr('data-event-on-action', 'camchat:reaction');
                }
                $messageTime.html(timeText);

                if (messageData.price_value !== undefined) {

                    // Weitere Unterscheidung und Vorverarbeitung findet im BackEnd statt
                    $messagePrice.html(messageData.price_value);
                    $messagePriceWrapper.removeClass('hidden');

                    if (messageData.tip == 0) {
                        $tipBag.addClass("hidden");
                    }
                }

                if (messageData.mediaData != undefined) {

                    let $imageHolder = $mediaContainer.find('[data-type="message-image"]');
                    let $galleryHolder = $mediaContainer.find('[data-type="gallery"]');

                    let $imageIcon = $mediaContainer.find('[data-type="image-icon"]');
                    let $imageCounter = $mediaContainer.find('[data-type="image-counter"]');

                    let $videoIcon = $mediaContainer.find('[data-type="video-icon"]');
                    let $videoCounter = $mediaContainer.find('[data-type="video-counter"]');
                    let $videoDuration = $mediaContainer.find('[data-type="video-duration"]');

                    let imagesAmount = 0;
                    let videosAmount = 0;
                    let combinedVideoDuration = 0;

                    messageData.mediaData.forEach(function (media) {
                        if (media.media_type == "image") {
                            imagesAmount++;
                        } else if (media.media_type == "video") {
                            videosAmount++;
                            if (media.duration) {
                                combinedVideoDuration += parseInt(media.duration);
                            }
                        }
                    });
                    if (imagesAmount == 0) {
                        $imageIcon.remove();
                        $imageCounter.remove();
                    } else {
                        $imageCounter.html(imagesAmount);
                    }
                    if (videosAmount == 0) {
                        $videoIcon.remove();
                        $videoCounter.remove();
                        $videoDuration.remove();
                    } else if (videosAmount == 1) {
                        $videoCounter.remove();
                        $videoDuration.html(mySelf.formatVideoDuration(messageData.mediaData[0].duration));
                    } else {
                        $videoCounter.html(videosAmount);
                        $videoDuration.html(' &middot; ' + mySelf.formatVideoDuration(combinedVideoDuration));
                    }

                    let $galleryNextButton = $galleryHolder.find('[data-gallery-handler="next"]');
                    let firstMedia = true;

                    messageData.mediaData.every(function (media) {

                        let $autosizeimage = null;
                        let $videoplayer = null;

                        if (media.media_type == "image") {

                            if (media.preloaderurl != undefined) {
                                // preloaderurl vorhanden, ist also noch nicht verarbeitet worden
                                if (media.blurred == 1) {
                                    $autosizeimage = mySelf.loadImagePreloaderTemplate(media.preloaderurl, 1, false, false, false, firstMedia, true);
                                } else {
                                    $autosizeimage = mySelf.loadImagePreloaderTemplate(media.preloaderurl, 1, true, true, true, firstMedia, true);
                                }
                            } else {
                                if (media.blurred == 1) {
                                    $autosizeimage = mySelf.loadAutoSizeImageTemplate(media, 1, false, false, false, firstMedia, true);
                                } else {
                                    $autosizeimage = mySelf.loadAutoSizeImageTemplate(media, 1, true, true, true, firstMedia, true);
                                }
                            }
                        } else if (media.media_type == "video") {

                            if (media.preloaderurl != undefined) {
                                // preloaderurl vorhanden, ist also noch nicht verarbeitet worden
                                if (media.blurred == 1) {
                                    $videoplayer = mySelf.loadVideoPreloaderTemplate(media.preloaderurl, true, false, false, firstMedia, true);
                                } else {
                                    $videoplayer = mySelf.loadVideoPreloaderTemplate(media.preloaderurl, false, true, true, firstMedia, true);
                                }
                            } else {
                                if (media.blurred == 1) {
                                    // Videopreloader wird nicht geladen, da nicht gekauft, oder AVS
                                    $autosizeimage = mySelf.loadAutoSizeImageTemplate(media, 1, false, false, false, firstMedia, true);
                                } else {
                                    $videoplayer = mySelf.loadVideoplayerTemplate(media.videoUrl, media, 1, true, true, true, firstMedia, false, false, true);
                                }
                            }
                        }

                        if (messageData.purchasable || messageData.avs_required || messageData.mediaData.length == 1) {
                            // Wenn nur ein einzelner Upload vorhanden ist, oder gekauft, bzw. AVS gemacht werden muss, oder die Uploads noch geprüft werden müssen dann zeigen wir keine Gallerie an
                            if ($autosizeimage != null) {
                                $imageHolder.append($autosizeimage);
                            }
                            if ($videoplayer != null) {
                                $imageHolder.append($videoplayer);
                            }
                            $galleryHolder.remove();
                            return false;
                        } else {
                            $imageHolder.remove();
                        }

                        if ($autosizeimage != null) {
                            $galleryNextButton.before($autosizeimage);
                        }
                        if ($videoplayer != null) {
                            $galleryNextButton.before($videoplayer);
                        }

                        firstMedia = false;

                        return true;
                    });

                    $galleryHolder.attr('data-state', 'init');
                    $galleryHolder.find('[data-type="gallery-items-count"]').html(messageData.mediaData.length);

                } else {
                    $mediaContainer.remove();
                }

                let $messageReportBtn = $messageContainer.find('[data-btn="conversation_report"]')
                let $messageDeleteBtn = $messageContainer.find('[data-btn="conversation_delete"]')

                if (messageData.isCreatorMessage != undefined && messageData.isCreatorMessage) {
                    // camchat
                    $messageContainer.addClass('message__creator');
                }

                if (messageData.own) {
                    $messageContainer.addClass('message__own');
                    $messageContainer.attr('own', 1);
                    $purchaseButtonsContainer.remove();
                    $purchaseCancelButton.remove();
                    $avsButton.remove();

                    // Erhalten, gelesen Markierungen
                    if (messageData.read_at !== undefined) {
                        $messageContainer.find('[data-type="msg-received-check"]').remove();
                        $messageContainer.attr('data-read-state', 1);
                    } else {
                        $messageContainer.find('[data-type="msg-read-check"]').addClass('hidden');
                        $messageContainer.attr('data-read-state', 0);
                    }

                    $messageReportBtn.remove();
                    $messageDeleteBtn.attr('data-modaldata', 'msg=' + messageData.id);
                } else {
                    $messageContainer.addClass('message__other');
                    $messageContainer.attr('own', 0);

                    if (messageData.avs_required == 0) {
                        $avsButton.remove();
                    }

                    // Erhalten, gelesen Markierungen
                    if (messageData.read_at !== undefined) {
                        $messageContainer.attr('data-read-state', 1);
                    } else {
                        $messageContainer.attr('data-read-state', 0);
                    }

                    $messageContainer.find('[data-type="msg-received-check"]').remove();
                    $messageContainer.find('[data-type="msg-read-check"]').remove();

                    $messageDeleteBtn.remove();
                    $messageReportBtn.attr('data-modaldata', 'msg=' + messageData.id);
                }

                if (messageData.uploads_article != undefined) {

                    if (messageData.own) {

                        if (messageData.upload_purchase_state == "received" || messageData.upload_purchase_state == "prepurchased") {
                            $purchaseStateHolder.find('[data-type="cr_rejected"]').remove();
                            $purchaseStateHolder.find('[data-type="cr_purchased"]').remove();

                            $purchaseStateHolder.find('[data-type="rejected"]').remove();
                            $purchaseStateHolder.find('[data-type="purchased"]').remove();
                            $purchaseStateHolder.find('[data-type="received"]').remove();


                        } else if (messageData.upload_purchase_state == "purchased") {
                            $purchaseStateHolder.find('[data-type="cr_rejected"]').remove();
                            $purchaseStateHolder.find('[data-type="cr_received"]').remove();

                            $purchaseStateHolder.find('[data-type="rejected"]').remove();
                            $purchaseStateHolder.find('[data-type="received"]').remove();
                            $purchaseStateHolder.find('[data-type="purchased"]').remove();

                        } else {
                            $purchaseStateHolder.find('[data-type="cr_purchased"]').remove();
                            $purchaseStateHolder.find('[data-type="cr_received"]').remove();

                            $purchaseStateHolder.find('[data-type="purchased"]').remove();
                            $purchaseStateHolder.find('[data-type="received"]').remove();
                            $purchaseStateHolder.find('[data-type="rejected"]').remove();
                        }

                        $purchaseStateHolder.find('[data-type="upload_price"]').html(messageData.upload_price_value);

                    } else {


                        if (messageData.upload_purchase_state == "received") {

                            $purchaseStateHolder.remove();
                            let $purchaseButton = $purchaseButtonsContainer.find('[data-btn="purchase-button"]');
                            let $purchaseNotPossible = $purchaseButtonsContainer.find('[data-type="purchase-not-possible"]');

                            if (messageData.purchase_not_possible) {
                                $purchaseButton.remove();
                            } else {
                                $purchaseNotPossible.remove();
                                let purchaseUrl = $purchaseButton.attr('data-action-url');
                                purchaseUrl = purchaseUrl.replace('hashID', messageData.uploads_article);
                                $purchaseButton.attr('data-action-url', purchaseUrl);
                                $purchaseButton.attr('data-state', 'init');

                                let puchasePriceString = $purchaseButton.html();
                                puchasePriceString = puchasePriceString.replace('price_placeholder', messageData.upload_price_value);
                                $purchaseButton.html(puchasePriceString);
                            }

                            $avsButton.remove();

                        } else if (messageData.upload_purchase_state == "purchased" || messageData.upload_purchase_state == "prepurchased") {

                            $purchaseButtonsContainer.remove();
                            $purchaseCancelButton.remove();

                            $purchaseStateHolder.find('[data-type="cr_received"]').remove();
                            $purchaseStateHolder.find('[data-type="cr_purchased"]').remove();
                            $purchaseStateHolder.find('[data-type="cr_rejected"]').remove();

                            $purchaseStateHolder.find('[data-type="received"]').remove();
                            $purchaseStateHolder.find('[data-type="rejected"]').remove();

                            $purchaseStateHolder.find('[data-type="upload_price"]').html(messageData.upload_price_value);

                        } else {
                            $purchaseButtonsContainer.remove();
                            $purchaseCancelButton.remove();

                            $purchaseStateHolder.find('[data-type="cr_received"]').remove();
                            $purchaseStateHolder.find('[data-type="cr_purchased"]').remove();
                            $purchaseStateHolder.find('[data-type="cr_rejected"]').remove();

                            $purchaseStateHolder.find('[data-type="received"]').remove();
                            $purchaseStateHolder.find('[data-type="purchased"]').remove();

                            $purchaseStateHolder.find('[data-type="upload_price"]').html(messageData.upload_price_value);
                            $avsButton.remove();
                        }
                    }
                } else {
                    $purchaseButtonsContainer.remove();
                    $purchaseStateHolder.remove();
                    $purchaseCancelButton.remove();
                }
            }

            parentHTML = parentHTML + $messageContainer[0].outerHTML;
        }

        return parentHTML;
    }

    formatVideoDuration(seconds)
    {
        seconds = Math.round(seconds)

        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;

        const timeParts = h > 0 ? [h] : [];
        timeParts.push(String(m).padStart((h > 0 ? 2 : 1), '0'));
        timeParts.push(String(s).padStart(2, '0'));

        return timeParts.join(':');
    }

    loadUserTypingTemplate($parentContainer, userData, content) {

        if ($parentContainer == undefined) {
            return;
        }

        let $typingContainer = $parentContainer.find('[data-user-id="' + userData.userID + '"]').first();

        if ($typingContainer.length == 0) {
            $typingContainer = this.getTemplate('js-user_typing_tpl');
            // $typingContainer.find('.js-message').html(content);
            $typingContainer.attr('data-user-id', userData.userID);
            this.fillUserData($typingContainer, userData.userID, userData.username, userData.avatar, userData.usertype, userData.isOnline, userData.user_last_activity_at);
            $parentContainer.append($typingContainer);
            $parentContainer.scrollTop($parentContainer[0].scrollHeight);
        }

    }

    getTemplate(templateID) {
        let $template = $("#" + templateID).contents().filter(function () {
            return this.nodeType === 1;
        }).clone();
        if ($template.length == 0) {
            console.error("template " + templateID + "not found");
        }
        return $template;
    }

    loadConversationDateTemplate($parentContainer, messageData, parentHTML) {

        let $dateContainer = $parentContainer.find('[data-date-id="' + messageData.id + '"]').first();

        if ($dateContainer.length == 0) {

            $dateContainer = this.getTemplate('js-conversation_date_tpl');
            $dateContainer.attr('data-date-id', messageData.id);
            $dateContainer.html(messageData.date);

            parentHTML = parentHTML + $dateContainer[0].outerHTML;
        }

        return parentHTML;

    }
}
